import { render, staticRenderFns } from "./PromoShow.vue?vue&type=template&id=7bbd0cee"
import script from "./PromoShow.vue?vue&type=script&lang=js"
export * from "./PromoShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports